<template>
  <div class="paper" style="overflow-y: scroll;">
    <div style="background-color: #fff; height: 35px;position: fixed; left: 0px; top: 80px; border-bottom: 1px dotted #ccc;">
      <div class="date">{{page.Date}}</div>
      <div style="float: left; padding-left: 150px; padding-top: 5px; font-size: 16px;">
        <span>מזג אויר: </span>
        <span v-if="diaryPage">
          <input v-if="canAdd()" type="text" style="text-align: center; width: 250px!important;" v-model="diaryPage.Weather" placeholder="הכנס מזג אויר" />
          <span v-else v-html="diaryPage.Weather"></span>
        </span>
        <span v-else>
          <input v-if="canAdd()" type="text" style="text-align: center;" v-model="page.Weather" placeholder="הכנס מזג אויר" />
          <span v-else v-html="page.Weather"></span>
        </span>
      </div>
    </div>

    <div style="width: 100%;margin-top: 34px; font-size: 20px; text-align: center;">
      <v-layout row wrap style="padding: 10px;">
        <v-flex xs12 style="border: 1px #aaa solid; border-radius: 10px; width: 100%">
          <v-layout row wrap style="padding: 10px;">
            <v-flex xs3>
              <div style="text-decoration: underline;text-align: right;float: right; padding-top: 10px;">הערות כלליות</div>
              <v-icon v-if="canAdd()" style="text-decoration: none; font-size: 25px; width: 25px!important; height: 25px!important; float: right;" @click="addGeneralNote()" class="btnAdd " v-tooltip:left="{ html: 'הוסף תיאור' }">add</v-icon>
            </v-flex>
          </v-layout>
          <NoteEditor v-if="$root.isNewGeneralNote" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
          <div v-if="notesGeneral && notesGeneral.length > 0">
            <Note v-for="(note,index) in notesGeneral" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
          </div>
          <div v-else>
            <h5 style="padding-top: 20px; color: #aaa;">אין נתונים</h5>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div style="width: 100%;margin-top: 34px; font-size: 20px; text-align: center;">
     <v-layout row wrap style="padding: 10px;">
        <v-flex xs12 style="border: 1px #aaa solid; border-radius: 10px; width: 100%">
          <v-layout row wrap style="padding: 10px;">
            <v-flex xs3>
              <div style="text-decoration: underline;text-align: right;float: right; padding-top: 10px;">תיאור העבודה</div>
              <v-icon v-if="canAdd()" style="text-decoration: none; font-size: 25px; width: 25px!important; height: 25px!important; float: right;" @click="addInfoNote" class="btnAdd " v-tooltip:left="{ html: 'הוסף תיאור' }">add</v-icon>
            </v-flex>
          </v-layout>
          <NoteEditor v-if="$root.isNewInfoNote" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
          <div v-if="notesInfo && notesInfo.length > 0">
            <Note v-for="(note,index) in notesInfo" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
          </div>
          <div v-else>
            <h5 style="padding-top: 20px; color: #aaa;">אין נתונים</h5>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-layout row wrap style="padding: 10px;">
      <v-flex xs6 style="border: 1px #aaa solid; border-radius: 10px;  width: 48%; margin: 1%;">
        <div style="width: 100%!important;display: block;padding-bottom: 40px;">
          <div style="margin: 15px; float: right; font-size: 20px; text-align: right;text-decoration: underline;">הערות מנהל עבודה:</div>
          <v-icon v-if="$root.isContractor && canAdd()" @click="addNote" class="btnAdd" style="text-decoration: none; font-size: 25px; width: 25px!important; height: 25px!important; float: right;" v-tooltip:left="{ html: 'הוסף הערה' }">add</v-icon>
        </div>
        <div>
          <NoteEditor v-if="$root.isNewNote && $root.isContractor" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
          <div v-if="notesContractor && notesContractor.length > 0">
            <Note v-for="(note,index) in notesContractor" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
          </div>
          <div v-else>
            <h5 style="padding-top: 20px; color: #aaa;">אין נתונים</h5>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 style="border: 1px #aaa solid; border-radius: 10px;  width: 48%; margin: 1%;">
        <div style="width: 100%!important;display: block;padding-bottom: 40px;">
          <div style="margin: 15px; float: right; font-size: 20px; text-align: right;text-decoration: underline;">הערות מפקח:</div>
          <v-icon v-if="$root.isInspector && canAdd()" @click="addNote" class="btnAdd" style="text-decoration: none; font-size: 25px; width: 25px!important; height: 25px!important; float: right;" v-tooltip:left="{ html: 'הוסף הערה' }">add</v-icon>
        </div>
        <div>
          <NoteEditor v-if="$root.isNewNote && $root.isInspector" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
          <div v-if="notesInspector && notesInspector.length > 0">
            <Note v-for="(note,index) in notesInspector" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
          </div>
          <div v-else>
            <h5 style="padding-top: 20px; color: #aaa;">אין נתונים</h5>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  import { db } from '../firebase';
  var pagesRef = db.ref('DiaryPages');
  import Note from '../components/Note';
  import NoteEditor from '../components/NoteEditor';

  export default {
    name: 'DiaryPage',
    props: ['pageKey', 'txtSearch', 'page', 'location'],
    components: { Note, NoteEditor },
    data() {
      return {
        currentDate: '',
        currentTime: '',
        diaryPage: null,
        isNew: false,
      }
    },
    firebase: function () {
      var vm = this;
      var notesPath = 'DiaryPages/' + vm.page.PageKey + '/Notes';
      var notesRef = db.ref(notesPath);
      return {
        allNotes: notesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [DiaryPage] is created ...");
      if (this.pageKey) {
        this.loadPage();
      }
    },
    ready() {
      this.$Log("Vue [DiaryPage] is ready ...");
    },
    mounted() {
      this.$Log("Vue [DiaryPage] is mounted ...");
    },
    updated() {
      this.$Log("Vue [DiaryPage] is updated ...");
    },
    computed: {
      weatherInfo() {
        let wth = 'אין נתונים';
        if (this.$root.weather) {
          if (this.$root.weather.currently) {
            wth = this.$root.weather.currently.summary + ' ' + Math.round(this.$root.weather.currently.temperature) + '°';
          }
        }
        return wth;
      },
      //pageKey() {
      //  var vm = this;
      //  if (vm.page.PageKey == undefined) {
      //     return "";
      //  }
      //  else {
      //    return vm.page.PageKey;
      //  }
      //},
      //notesCounter() {
      //  if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
      //    return Object.keys(this.diaryPage.Notes).length;
      //  }
      //  else {
      //    return 0;
      //  }
      //},
      notes() {
        if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
          return this.diaryPage.Notes;
        }
      },
      filteredNotes() {
        var vm = this;
        var result = [];
        if (vm.diaryPage != undefined && vm.diaryPage != null && vm.diaryPage.Notes) {
          var keys = Object.keys(vm.diaryPage.Notes);
          for (var i = 0; i < keys.length; i++) {
            let k = keys[i];
            let note = vm.diaryPage.Notes[k];
            var txt = String(vm.txtSearch);
            if (txt.length > 0) {
              Object.keys(note).some(function (key) {
                console.log(key)
                if (key != "IsGeneral" && key != "IsInfo") {
                  if (String(note[key]).trim().toLowerCase().indexOf(txt.trim().toLowerCase()) > -1) {
                    result.push(note);
                  }
                }
              });
            }
            else {
              result.push(note);
            }
          }
        }

        return result;
      },
      notesGeneral() {
        var arr = [];
        for (var i = 0; i < this.filteredNotes.length; i++) {
          if (this.filteredNotes[i].IsGeneral) {
            arr.push(this.filteredNotes[i]);
          }
        }

        return arr;
      },
      notesInfo() {
        var arr = [];
        for (var i = 0; i < this.filteredNotes.length; i++) {
          if (this.filteredNotes[i].IsInfo) {
            arr.push(this.filteredNotes[i]);
          }
        }

        return arr;
      },
      notesInspector() {
        var arr = [];
        for (var i = 0; i < this.filteredNotes.length; i++) {
          if (!this.filteredNotes[i].IsInfo && !this.filteredNotes[i].IsGeneral) {
            if (this.filteredNotes[i].UserType == 'מפקח') {
              arr.push(this.filteredNotes[i]);
            }
          }
        }

        return arr;
      },
      notesContractor() {
        var arr = [];
        for (var i = 0; i < this.filteredNotes.length; i++) {
          if (!this.filteredNotes[i].IsInfo && !this.filteredNotes[i].IsGeneral) {
            if (this.filteredNotes[i].UserType == 'מנהל עבודה') {
              arr.push(this.filteredNotes[i]);
            }
          }
        }

        return arr;
      },
      //notesGeneral() {
      //  var arr = [];
      //  if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
      //    var keys = Object.keys(this.diaryPage.Notes);
      //    for (var i = 0; i < keys.length; i++) {
      //      let k = keys[i];
      //      if (this.diaryPage.Notes[k].IsGeneral) {
      //        arr.push(this.diaryPage.Notes[k]);
      //      }
      //    }
      //  }

      //  return arr;
      //},
      
      //notesInfo() {
      //  var arr = [];
      //  if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
      //    var keys = Object.keys(this.diaryPage.Notes);
      //    for (var i = 0; i < keys.length; i++) {
      //      let k = keys[i];
      //      if (this.diaryPage.Notes[k].IsInfo) {
      //        arr.push(this.diaryPage.Notes[k]);
      //      }
      //    }
      //  }

      //  return arr;
      //},
      //notesInspector() {
      //  var arr = [];
      //  if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
      //    var keys = Object.keys(this.diaryPage.Notes);
      //    for (var i = 0; i < keys.length; i++) {
      //      let k = keys[i];
      //      if (!this.diaryPage.Notes[k].IsInfo && !this.diaryPage.Notes[k].IsGeneral) {
      //        if (this.diaryPage.Notes[k].UserType == 'מפקח') {
      //          arr.push(this.diaryPage.Notes[k]);
      //        }
      //      }
      //    }
      //  }

      //  return arr;
      //},
      //notesContractor() {
      //  var arr = [];
      //  if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
      //    var keys = Object.keys(this.diaryPage.Notes);
      //    for (var i = 0; i < keys.length; i++) {
      //      let k = keys[i];
      //      if (!this.diaryPage.Notes[k].IsInfo && !this.diaryPage.Notes[k].IsGeneral) {
      //        if (this.diaryPage.Notes[k].UserType == 'מנהל עבודה') {
      //          arr.push(this.diaryPage.Notes[k]);
      //        }
      //      }
      //    }
      //  }

      //  return arr;
      //},
    },
    watch: {
      pageKey(val) {
        this.loadPage();
      },
    },
    methods: {
      updateNotesCounter(vm, objNotes) {
        if (objNotes) {
          var keys = Object.keys(objNotes);
          vm.counter = keys.length;
        }
        else {
          vm.counter = 0;
        }
      },
      loadPage() {
        var vm = this;
        //alert('reload...')
        vm.$root.isNewNote = false;
        vm.$root.isNewGeneralNote = false;
        vm.$root.isNewInfoNote = false;
        vm.diaryPage = null;
        var pageKey = vm.page.PageKey;
        if (pageKey == undefined) {
          pageKey = "";
        }
        pagesRef.orderByKey().equalTo(pageKey).once('value').then(function (snapshotPage) {
          let obj = snapshotPage.val();
          if (obj) {
            let keyP = Object.keys(obj)[0];
            if (obj[keyP].Notes) {
              var notesKeys = Object.keys(obj[keyP].Notes);
              for (var k = 0; k < notesKeys.length; k++) {
                var key = notesKeys[k];
                obj[keyP].Notes[key]['.key'] = key;
              }
            }
            vm.diaryPage = obj[keyP];
            //diary.Image = proj.Images[0];
            //vm.statuses.filter(function (st) {
            //  if (st['.key'] == proj.StatusKey) {
            //    diary.Status = st;
            //    diary.Color = st.Color;
            //    vm.diaries.push(diary);
            //    return false;
            //  }
            //})
          }
          else {
          }
        });
      },
      addInfoNote() {
        var vm = this;

        vm.currentDate = vm.$moment().format('DD/MM/YYYY');
        vm.currentTime = vm.$moment().format('HH:mm');
        vm.$root.isNewGeneralNote = false;
        vm.$root.isNewInfoNote = true;

        vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
          if (!error) {
            vm.$root.weather = data;
            //alert(data.currently.time)
            //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
            //vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
            //vm.$root.isNewGeneralNote = false;
            //vm.$root.isNewInfoNote = true;
          }
        });
      },
      addGeneralNote() {
        var vm = this;
        console.log('addGeneralNote()')

        vm.currentDate = vm.$moment().format('DD/MM/YYYY');
        vm.currentTime = vm.$moment().format('HH:mm');
        vm.$root.isNewGeneralNote = true;
        vm.$root.isNewInfoNote = false;

        vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
          if (!error) {
            vm.$root.weather = data;
            //alert(data.currently.time)
            //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
            //vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
            //vm.$root.isNewGeneralNote = true;
            //vm.$root.isNewInfoNote = false;
          }
        });
      },
      addNote() {
        var vm = this;

        vm.currentDate = vm.$moment().format('DD/MM/YYYY');
        vm.currentTime = vm.$moment().format('HH:mm');
        vm.$root.isNewNote = true;
        vm.$root.isNewGeneralNote = false;
        vm.$root.isNewInfoNote = false;

        vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
          if (!error) {
            vm.$root.weather = data;
            //alert(data.currently.time)
            //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
            //vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
            //vm.$root.isNewNote = true;
            //vm.$root.isNewGeneralNote = false;
            //vm.$root.isNewInfoNote = false;
          }
        });
      },
      canAdd() {
        return (this.$parent.currentDate == this.page.Date && !this.$root.isObserver);
      },
      canEdit(note) {
        if (this.$parent.currentDate == this.page.Date){
          return note.UserKey == this.$root.user['.key'];
        }
        return false;
      }
    }
  }

</script>
<style>
  .paper {
    min-height: 100%;
    width: 100%;
    height: auto;
    font: normal 12px/1.5 "Lucida Grande", arial, sans-serif;
    margin: 0 auto;
    padding: 6px 20px 4px 20px;
    position: relative;
    color: #444;
    border: 1px solid #d2d2d2;
    background: #fff !important;
    /*background: -webkit-gradient(linear, 0 0, 0 100%, from(#d9eaf3), color-stop(5%, #fff)) 0 4px !important;*/
    -webkit-background-size: 100% 30px !important;
    -moz-background-size: 100% 30px !important;
    -ms-background-size: 100% 30px !important;
    -o-background-size: 100% 30px !important;
    background-size: 100% 30px !important;
    /*-webkit-box-shadow: 0 1px 2px rgba(0,0,0,0.07) !important;
    -moz-box-shadow: 0 1px 2px rgba(0,0,0,0.07) !important;
    box-shadow: 0 1px 2px rgba(0,0,0,0.07) !important;*/
  }

    .paper::before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      right: 10px;
      bottom: 0;
      border: 1px solid;
      border-color: transparent #efe4e4;
    }

    /*.paper .scheduleList {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      text-align: right;
      direction: rtl;
    }*/

    .paper > div > div.date {
      /*width: 95%;*/
      height: 28px;
      background-color: rgba(255,255,0,0.1);
      line-height: 28px;
      font-size: 18px;
      text-align: left;
      position: fixed;
      left: 20px;
      padding: 2px;
    }

    .paper > div > i.note {
      width: 25px !important;
      height: 25px !important;
      font-size: 25px;
      position: fixed;
      right: 260px;
      top: 77px;
    }
</style>



// WEBPACK FOOTER //
// DiaryPage.vue?71b51588